/* tslint:disable */
/* eslint-disable */
/**
 * Lemonway DirectKit API 2.0
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v2
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface MoneyInSddInitInput
 */
export interface MoneyInSddInitInput {
    /**
     * Mandate ID
     * @type {number}
     * @memberof MoneyInSddInitInput
     */
    sddMandateId: number;
    /**
     * Debit date of the bank account, must be later than the default date.
     * Leave empty in order to use the default date: current date + 1 working days before 10:30 AM or current date + 2 working days after.
     * @type {string}
     * @memberof MoneyInSddInitInput
     */
    collectionDate?: string;
    /**
     * Unique ID of the call, generated by your server. This ID can be used as a search field when looking for operation details
     * @type {string}
     * @memberof MoneyInSddInitInput
     */
    reference?: string;
    /**
     * Payment Account ID to Credit
     * @type {string}
     * @memberof MoneyInSddInitInput
     */
    accountId: string;
    /**
     * Amount to Debit
     * Amounts are given as integer numbers in cents
     * @type {number}
     * @memberof MoneyInSddInitInput
     */
    totalAmount?: number;
    /**
     * Your Fee
     * Amounts are given as integer numbers in cents
     * @type {number}
     * @memberof MoneyInSddInitInput
     */
    commissionAmount?: number;
    /**
     * Comment Regarding the Transaction
     * @type {string}
     * @memberof MoneyInSddInitInput
     */
    comment?: string;
    /**
     * If true:
     * 1. [amountCom] will be ignored and will be replaced with Lemonway's fee
     * 2. You will not receive any fee
     * @type {boolean}
     * @memberof MoneyInSddInitInput
     */
    autoCommission?: boolean;
}

/**
 * Check if a given object implements the MoneyInSddInitInput interface.
 */
export function instanceOfMoneyInSddInitInput(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "sddMandateId" in value;
    isInstance = isInstance && "accountId" in value;

    return isInstance;
}

export function MoneyInSddInitInputFromJSON(json: any): MoneyInSddInitInput {
    return MoneyInSddInitInputFromJSONTyped(json, false);
}

export function MoneyInSddInitInputFromJSONTyped(json: any, ignoreDiscriminator: boolean): MoneyInSddInitInput {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'sddMandateId': json['sddMandateId'],
        'collectionDate': !exists(json, 'collectionDate') ? undefined : json['collectionDate'],
        'reference': !exists(json, 'reference') ? undefined : json['reference'],
        'accountId': json['accountId'],
        'totalAmount': !exists(json, 'totalAmount') ? undefined : json['totalAmount'],
        'commissionAmount': !exists(json, 'commissionAmount') ? undefined : json['commissionAmount'],
        'comment': !exists(json, 'comment') ? undefined : json['comment'],
        'autoCommission': !exists(json, 'autoCommission') ? undefined : json['autoCommission'],
    };
}

export function MoneyInSddInitInputToJSON(value?: MoneyInSddInitInput | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'sddMandateId': value.sddMandateId,
        'collectionDate': value.collectionDate,
        'reference': value.reference,
        'accountId': value.accountId,
        'totalAmount': value.totalAmount,
        'commissionAmount': value.commissionAmount,
        'comment': value.comment,
        'autoCommission': value.autoCommission,
    };
}

